import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import {
    BookRidePlan,
    GeocodeAddress,
    MapCoordinates,
    MapIcons,
    ProductsSelectorFacade,
    RidePlannerFacade
} from '@ridango/components';
import { LatLng, MapPoint } from '@ridango/core';
import Env from '@ridango/core/env';

import { take } from 'rxjs/operators';

@Component({
    templateUrl: './book-ride-plan-page.component.html',
    styleUrls: ['./book-ride-plan-page.component.scss']
})
export class BookRidePlanPageComponent implements OnInit {
    zoom = 13;
    mapCenter: MapCoordinates = this.env.MAP.COORDINATES;
    selectedPoint: MapPoint;
    selectedLocation: GeocodeAddress;
    pickup: GeocodeAddress;
    dropOff: GeocodeAddress;
    clickedStop: GeocodeAddress;

    iconOrigin = MapIcons('pin');
    iconDestination = MapIcons('origin');
    iconStop = MapIcons('bus-stop');
    potentialStops$ = this.ridePlanner.potentialStops$;
    isFullMap = false;

    constructor(
        @Inject('ENV') public env: Env,
        private ridePlanner: RidePlannerFacade,
        private router: Router,
        private translate: TranslateService,
        private productsSelector: ProductsSelectorFacade
    ) {}

    ngOnInit() {
        this.ridePlanner.step$.pipe(take(1)).subscribe((step) => step !== 1 && this.ridePlanner.setStep(1));
        this.productsSelector.resetSelected();
    }

    handleSubmit(ridePlan: BookRidePlan) {
        this.ridePlanner.addPlan(ridePlan);
        this.router.navigate([this.translate.currentLang, 'book-a-ride', 'specify']);
    }

    onPointClicked(coordinates: LatLng) {
        this.selectedLocation = null;
        this.selectedPoint = null;
        this.ridePlanner
            .fetchGeocodeAddressByCoordinates(coordinates.lat, coordinates.lng)
            .pipe(take(1))
            .subscribe((location) => {
                this.selectedLocation = { lat: location.lat, lon: location.lon, address: location.formatted };
                this.selectedPoint = { lat: location.lat, lng: location.lon, address: location.formatted };
            });
    }

    onStopClicked(event): void {
        this.clickedStop = event;
    }

    onDepartureClicked(event): void {
        this.pickup = event;
    }

    onDestinationClicked(event): void {
        this.dropOff = event;
    }

    onMapDeparture() {
        this.pickup = this.selectedLocation;
    }

    onMapDestination() {
        this.dropOff = this.selectedLocation;
    }

    onFormDeparture(address: GeocodeAddress) {
        this.pickup = address;
    }

    onFormDestination(address: GeocodeAddress) {
        this.dropOff = address;
    }

    toggleMapSize() {
        this.isFullMap = !this.isFullMap;
    }
}
